import { NgModule } from "@angular/core";
import { AiAgentMarkdownPipe } from "./ai-agent-markdown.pipe";

@NgModule({
  declarations: [AiAgentMarkdownPipe],
  exports: [AiAgentMarkdownPipe],
})
export class AiAgentMarkdownModule {}
